// bernie
import { Store } from 'bernie-plugin-mobx';
import { SerializedData } from 'bernie-core';
import { Logger, NOOP_LOGGER } from 'bernie-logger';

// mobx
import { action } from 'mobx';

// data
import { Legal } from 'models';
import { LegalSource } from '../sources';

export class LegalStore extends Store {
  private legalSource: LegalSource;

  public constructor(legalSource: LegalSource, state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
    this.legalSource = legalSource;
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this.legalSource, data.legalSource);
  }

  @action
  public getConfig(siteId: number): Legal {
    return this.legalSource.getConfig(siteId);
  }
}
